import { SuccessCircleIcon } from '@/app/common/icons/general'
import { Button } from '@/common/components/Button'
import { AppRoutePaths } from '@/routing/route_paths'
import { RootState } from '@/storage/store'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import useTaxableIncomeDocumentParams from '../hooks/useTaxableIncomeDocumentParams'

export const DocumentSubmittedPage = () => {
  const { t: translate } = useTranslation()
  const { info, onFormSubmitted, selectedOption, onRouteChange } =
    useTaxableIncomeDocumentParams()
  const ProgramSettings = useSelector(
    (state: RootState) => state.ProgramSettings
  )
  return (
    <section
      id="income-verification"
      aria-labelledby="income-verification-title"
    >
      <h1
        id="income-verification-title"
        className="text-3xl text-center font-medium text-gray-900 mb-10 sm:mb-5"
      >
        {translate('success')}
      </h1>

      <div className="flex justify-center" aria-hidden="true">
        <SuccessCircleIcon />
      </div>
      <p className="text-lg text-center mt-3 px-10">
        {translate('document_submitted')}
      </p>

      <div className="mt-6">
        <p className="flex items-center text-center text-sm px-5">
          {translate('your')} {translate(info().longName)}{' '}
          {translate('was_successfully_submittedd')}.
        </p>
      </div>

      <div className="text-center mt-10 flex">
        <div className="flex justify-end w-full mb-5 flex-col gap-5">
          {selectedOption &&
            (selectedOption === 'form_1099' ||
              selectedOption === 'form_w2') && (
              <>
                <div className="text-left items-center rounded-md px-2 py-2 text-xs font-medium ring-1 ring-inset bg-primary-50 ring-primary-600/20">
                  <h2 className="block w-full text-xs font-semibold mb-1">
                    {translate('another_tax_document')}
                  </h2>
                  <p className="text-gray-800">
                    {translate('you_have_multiple')}{' '}
                    {ProgramSettings.data?.acceptable_income_year}
                    ,{' '}{translate('be_sure_to_upload_them')}.
                  </p>
                </div>
                <Button
                  onClick={() => {
                    onRouteChange(
                      AppRoutePaths.family_application.income_verification
                        .capture_instructions
                    )
                  }}
                  className="h-9 ring-primary text-primary"
                  variant="outline"
                >
                  {translate('upload_another_document')}
                </Button>
              </>
            )}
          <Button onClick={onFormSubmitted} className="rounded h-9">
            {translate('continue')}
          </Button>
        </div>
      </div>
    </section>
  )
}
